export default __webpack_public_path__ + "static/media/hamburger-icon.369e87c5.svg";